import { useEffect, useState } from "react"
import { SelectOptionType, SuccessFetch } from "types"
import { useApi } from "utils"

export function useDepartmentList() {
  const api = useApi()
  const [dataDepartment, setData] = useState<SelectOptionType[]>([])
  const [isLoadingDepartment, setLoading] = useState(false)

  const refetch = (divisi_id?: string) => {
    setLoading(true)

    api.get(
      "/department/",
      { params: { divisi_id } }
    )
    .then((res: SuccessFetch<{
      payload: {
        department_id: number
        department_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.department_name, value: item.department_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)

    api.get("/department/")
    .then((res: SuccessFetch<{
      payload: {
        department_id: number
        department_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.department_name, value: item.department_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
    // eslint-disable-next-line
  }, [])

  return { dataDepartment, isLoadingDepartment, refetch }
}